<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <h2 class="display-2 w-100 pb-5">Popis Škola</h2>
          <p
            class="mb-0"
          >Ovdje se nalazi popis županija i škola koje su uključene u projekt e-Škola preko Koordinacija ministara obrazovanja, znanosti, kulture i športa županija u kojima se nastavni planovi i programi izvode na hrvatskom jeziku.</p>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-expansion-panels focusable flat hover v-for="(item, i) in contacts" :key="i">
            <v-expansion-panel class="mb-2">
              <v-expansion-panel-header
                class="blue-text font-weight-medium py-7 text-uppercase"
              >{{ item.title }}</v-expansion-panel-header>
              <v-expansion-panel-content class="py-5 pb-0">
                <v-expansion-panels focusable flat hover v-for="(city, j) in item.cities" :key="j">
                  <v-expansion-panel style class="mb-2">
                    <v-expansion-panel-header
                      class="blue-text font-weight-medium py-7 text-uppercase"
                    >{{city.title}}</v-expansion-panel-header>
                    <v-expansion-panel-content class="py-5 pb-0">
                      <div v-for="(school, k) in city.schools" :key="k">
                        <v-row>
                          <v-col cols="1" sm="1">
                            <v-icon>fas fa-angle-double-right</v-icon>
                          </v-col>
                          <v-col cols="11" sm="8">
                            <p class="mb-0 pb-0">{{school.name}}</p>
                            <span class="grey--text"><v-icon size="17" left>fas fa-map-marker-alt</v-icon>{{school.address}}</span><br>
                            <span class="grey--text">
                                Kontakt mail:
                              <a
                                class="mail-link"
                                :href="'mailto:'+ school.contact_email"
                              >{{school.contact_email}}</a>
                            </span><br>
                            <span class="grey--text">
                                Informatička podrška:
                              <a
                                class="mail-link"
                                :href="'mailto:'+ school.contact_it"
                              >{{school.contact_it}}</a>
                            </span>
                          </v-col>
                          <v-col cols="1" class="hidden-sm-and-up"></v-col>
                          <v-col cols="11" sm="3">
                            <v-btn rounded="" color="#084776" class="text-capitalize mt-3" dark @click="showSchool(school.lat, school.lng)" href="#map">Prikaži na mapi</v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- <div v-if="item.lessons.length > 0">
													<div v-for="(x, key) in item.lessons" :key="key" class="mb-4">
														<router-link  :to="'/lekcije/' + x.id" class="blue-text">
															{{ x.title }}
														</router-link>
													</div>
												</div>
												<v-alert  text color="red" border="left" class="w-100 pl-7">
													Nema lekcija
                </v-alert>-->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row
					align="center"
					justify="center"
			>
				<v-col
						cols="12"
						md="8"
				>
					<v-select
							v-model="select"
							outlined
							color="#084776"
							label="Odaberite županiju"
							:items="zupanije"
							item-text="name"
							item-value="id"
					></v-select>
				</v-col>
			</v-row>
			<v-row id="map" class="mt-0 pt-0">
				<v-col
						cols="12"
						class="mt-0 pt-0"
				>
					<div>
						<gmap-map
								ref="mapRef"
								:options="{fullscreenControl: false, streetViewControl: false, zoomControl: true}"
								map-type-id="roadmap"
								:center="center"
								:zoom="zoom"
								style="width:100%;  height: 450px;"
								v-bind:options="mapStyle"
						>
							<gmap-marker
									:key="index"
									v-for="(m, index) in all_school"
									:position="m.position"
									:clickable="true"
									:draggable="false"
									:icon="{ url: m.type == 'Osnovna škola' ? require('@/assets/img/red.svg') : require('@/assets/img/blue.svg') }"
									@click="toggleInfoWindow(m,index)"
							>
								<v-img :src="m.img"></v-img>
							</gmap-marker>
							<gmap-info-window
									:options="infoOptions"
									:position="infoWindowPos"
									:opened="infoWinOpen"
									@closeclick="infoWinOpen=false"
							>
								<div style="width: 200px;">
									<v-row>
										<v-col cols="6">
											<v-img
													width="50px"
                          :src="require('@/assets/img/sumit-logo.png')"
											></v-img>
										</v-col>
										<v-col cols="6">
											<v-img
													width="50px"
                          :src="require('@/assets/img/logo.svg')"
											></v-img>
										</v-col>
										<v-col cols="12">
											<div
													style="height: 1px; background: linear-gradient(90deg, rgb(255, 255, 255), rgb(8, 71, 118), rgb(255, 255, 255));"
											></div>
										</v-col>
										<v-col cols="12">
											<h3 style="color: #084776">{{infoContent}}</h3>
										</v-col>
										<v-col cols="12">
											<p class="font">
												<v-icon
														left
														style="font-size: 16px;"
														color="#084776"
												>fas fa-map-marker-alt
												</v-icon>
												<span style="color: grey;">{{address}}</span>
											</p>
										</v-col>
									</v-row>
								</div>
							</gmap-info-window>
						</gmap-map>
					</div>
				</v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'Popis škola',
          disabled: true,
        },
      ],
      center: { lat: 44.200118, lng: 17.708905 },
      markers: [],
      places: [],
      zoom: 7,
      select: "all",
      currentPlace: null,
      infoContent: "",
      address: '',
      mapStyle: {
        disableDefaultUI: true,
        scrollwheel: true,
        styles: [
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36
              },
              {
                color: "#333333"
              },
              {
                lightness: 40
              }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on"
              },
              {
                color: "#ffffff"
              },
              {
                lightness: 16
              }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#fefefe"
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#fefefe"
              },
              {
                lightness: 17
              },
              {
                weight: 1.2
              }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "all",
            stylers: [
              {
                color: "#dee7ea"
              }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#121212"
              }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.stroke",
            stylers: [
              {
                weight: "0.01"
              }
            ]
          },
          {
            featureType: "administrative.province",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#121212"
              }
            ]
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#121212"
              }
            ]
          },
          {
            featureType: "administrative.neighborhood",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#121212"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: "#ff0000"
              },
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [
              {
                hue: "#ff0000"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#121212"
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                lightness: 20
              },
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#f0f5f7"
              },
              {
                lightness: 21
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#dedede"
              },
              {
                lightness: 21
              }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                visibility: "on"
              },
              {
                hue: "#ff0000"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#121212"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff"
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#ffffff"
              },
              {
                lightness: 29
              },
              {
                weight: 0.2
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff"
              },
              {
                lightness: 18
              }
            ]
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff"
              },
              {
                lightness: 16
              }
            ]
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#f2f2f2"
              },
              {
                lightness: 19
              }
            ]
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                color: "#ff0000"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff"
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#f0f5f7"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text",
            stylers: [
              {
                color: "#121212"
              }
            ]
          }
        ]
      },
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      currentMidx: null,
      all: [],
      zupanije: [
        {
          id: "all",
          name: "Prikaz svih škola"
        },
        {
          id: "hbz",
          name: "Hercegbosanska županija"
        },
        {
          id: "hnz",
          name: "Hercegovačko-neretvanska županija"
        },
        {
          id: 'zdz',
          name: 'Zeničko-dobojska županija'
        },
        {
          id: "pz",
          name: "Županija Posavska"
        },
        {
          id: "sbz",
          name: "Županija Središnja Bosna"
        },
        {
          id: "zzh",
          name: "Županija Zapadnohercegovačka"
        }
      ],
      contacts: [],
      all_school: []
    };
  },
  mounted() {
    this.getContacts();
    this.all = this.locations;
  },

  watch: {
    select: function() {
      this.changeLocations();
    }
  },
  methods: {
    getContacts: function() {
      axios
        .get("https://skole.sum.ba/admin/api/ostalo/skola/po_zupanijama")
        .then(response => {
          this.contacts = response.data;
          this.contacts.forEach(element => {
            element.cities.forEach(e1 => {
              e1.schools.forEach(e2 => {
                this.all_school.push({'position': { 'lat': Number(e2.lat), 'lng': Number(e2.lng) }, 'type': e2.type, 'address': e2.address, 'name': e2.name }
              )});
            });
          });
          // console.log(this.all_school);
        })
        .catch(error => console.log(error.message));
    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.name;
      this.address = marker.address;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    scrollToEnd: function() {
      var container = this.$el.querySelector("#map");
      container.scrollTop = container.scrollHeight;
    },

    showSchool(lat, lng){
      this.zoom = 17;
      console.log(lat, lng)
      this.center = { lat: Number(lat), lng: Number(lng) };
      this.scrollToEnd()
    },

    changeLocations: function() {
      if (this.select == "hbz") {
        this.zoom = 9;
        this.center = { lat: 43.964301, lng: 17.038054 };
      } else if (this.select == "hnz") {
        this.zoom = 9;
        this.center = { lat: 43.421638, lng: 17.793252 };
      } else if (this.select == "pz") {
        this.zoom = 11;
        this.center = { lat: 45.05722806766707, lng: 18.483246259662366 };
      } else if (this.select == "sbz") {
        this.zoom = 10;
        this.center = { lat: 44.203692, lng: 17.644843 };
      } else if (this.select == "zzh") {
        this.zoom = 10;
        this.center = { lat: 43.386654, lng: 17.545028 };
      } else if (this.select == "zdz") {
        this.zoom = 10;
        this.center = { lat: 44.550448, lng: 18.027489 };
      } else if (this.select == "all") {
        this.zoom = 7;
        this.center = { lat: 44.200118, lng: 17.708905 };
      }
    }
  }
};
</script>

<style>
.mail-link {
  text-decoration: none;
  color: #9e9e9e !important;
}

.mail-link:hover {
  color: red !important;
}
</style>
